<template>
  <header>
    <a
      href="#content-main"
      class="skippy">Skip directly to site content</a>
    <div class="container pb-2 pt-2">
      <div class="col cdc-logo">
        <!-- header-logo.html -->
        <!-- Begin included content (from /TemplatePackage/4.0/includes/header-logo.html) -->
        <a
          href="https://www.cdc.gov">
          <span class="sr-only">
            Centers for Disease Control and Prevention.
            CDC twenty four seven. Saving Lives, Protecting People
          </span>
          <svg
            width="470"
            height="47"
            class="d-none d-md-block logo-large"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="#masthead-subpage" />
          </svg>
        </a>
        <a
          href="https://www.cdc.gov"
          tabindex="-1">
          <span class="sr-only">
            Centers for Disease Control and Prevention.
            CDC twenty four seven. Saving Lives, Protecting People
          </span>
          <svg
            width="246"
            height="41"
            class="d-md-none logo-small"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="#masthead-1-col" />
          </svg>
        </a>
        <!-- End included content (from /TemplatePackage/4.0/includes/header-logo.html) -->
        <!-- header-logo.html -->
      </div>
    </div>
    <noscript>
      <div class="noscript">
      Note: Javascript is disabled or is not supported by your browser.
      For this reason, some items
      on this page will be unavailable.
      For more information about this message, please visit this page:
      <a
      href="/Other/about_cdcgov.html"
      title="Browser requirements for CDC.gov">About CDC.gov</a> .
      </div>
    </noscript>
    <div class="container-fluid site-title">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="display-6 text-white fw-500 pt-1 pb-1">
              <div>{{ systemName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container divHeaderNav">
      <div class="row rd-gridsystem-scrollbar-wrap">
        <div
          id="rcHeaderMenuLeft"
          class="rdResponsiveColumn col-lg-9 col-md-9 col-sm-9 col-xs-12"
          rdideidx="1|14">
          <span>
            <div>
              <a
                ref="lnkHome"
                :href="homeUrl"
                autofocus
              >Home</a>
              <router-link to="/LP">Explore by Indicator</router-link>
              <router-link to="/SP">Explore by Location</router-link>
              <router-link
                v-if="showComparisonReport"
                to="/CR">Comparison Report</router-link>
            </div>
          </span>
        </div>
        <div
          id="rcHeaderMenuRight"
          class="rdResponsiveColumn col-lg-3 col-md-3 col-sm-3 col-xs-12"
          rdideidx="1|16">
          <div>
            <a
              id="anch_5"
              :href="dataPortalUrl"
              target="_blank">Data Portal</a>
          </div>
        </div>
      </div>
    </div>
    <div
      id="divBreadcrumbs_"
      class="hidden-xs pad-left container">
      <span id="htmBreadcrumbs">
        <p>
          <a
            :href="breadCrumbUrl1"
            class="underline">Disability &amp; Health</a> &gt;
          <a
            :href="breadCrumbUrl2"
            class="underline">Data &amp; Statistics</a> &gt;
          <a
            :href="homeUrl"
            class="underline">Disability and Health Data System</a>
        </p>
      </span>
    </div>
    <h1 class="bg-white container mb-0 pad-left pageHeaderText pb-2 pt-2">{{ pageTitle }}</h1>
    <div
      id="clearSocialMediaFloat"
      class="pad-left" />
  </header>
</template>

<script>
/* global $ */
import { mapState } from 'vuex';

export default {
  name: 'PageHeader',
  computed: {
    ...mapState({
      route: state => state.route,
    }),
    systemName() {
      return `${process.env.SystemName} (${process.env.SystemAbbreviation})`;
    },
    homeUrl() {
      return process.env.HomeUrl;
    },
    dataPortalUrl() {
      return process.env.DataPortalUrl;
    },
    breadCrumbUrl1() {
      return process.env.BreadCrumbUrl1;
    },
    breadCrumbUrl2() {
      return process.env.BreadCrumbUrl2;
    },
    pageTitle() {
      return this.route.meta.pageTitle;
    },
    showComparisonReport() {
      return process.env.ShowComparisonReport;
    },
  },
  mounted() {
    // move the social media buttons from index.html into the page header
    // The social media buttons need to be in index.html for the socialmenu.js code
    // to work correctly.
    $('#clearSocialMediaFloat').append($('#socialMediaShareContainer'));
    // Remove the now empty parent to #socialMediaShareContainer
    $('#socialMediaTemp').remove();
  },
};
</script>

<style scoped>
.divHeaderNav a {
  color: white;
}

.pad-left {
  padding-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue